var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectangleProgress95(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_936_4964)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_936_4964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 13C4 8.02944 8.02944 4 13 4H17.666C18.2183 4 18.666 4.44772 18.666 5C18.666 5.55228 18.2183 6 17.666 6H13C9.13401 6 6 9.13401 6 13V41C6 44.866 9.13401 48 13 48H41C44.866 48 48 44.866 48 41V13C48 9.13401 44.866 6 41 6H28C27.4477 6 27 5.55228 27 5C27 4.44772 27.4477 4 28 4H41C45.9706 4 50 8.02944 50 13V41C50 45.9706 45.9706 50 41 50H13C8.02944 50 4 45.9706 4 41V13Z",
    fill: "#06C6C6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_936_4964",
    x: -1,
    y: -1,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_936_4964"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.027451 0 0 0 0 0.94902 0 0 0 0 0.94902 0 0 0 0.48 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_936_4964"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_936_4964",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_936_4964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangleProgress95);
export default __webpack_public_path__ + "static/media/rectangle-progress-95.5b2fbdd7d80eace9f879044ab2d98ee2.svg";
export { ForwardRef as ReactComponent };